import { render, staticRenderFns } from "./HcBadge.vue?vue&type=template&id=c56d8a54"
import script from "./HcBadge.vue?vue&type=script&lang=js"
export * from "./HcBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports